import styled from "styled-components";

// Botão-ícone do reenvio: superfície ADMIN (clara), então cor de texto escura.
export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray3};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.neutral.white};
  color: ${({ theme }) => theme.colors.neutral.black};
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary.vividCerulean};
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
`;
